import Image from "next/image";
import { IoBagAddSharp, IoAdd, IoRemove } from "react-icons/io5";
import { IoStarOutline, IoStarSharp, IoStarHalf } from "react-icons/io5";
import Price from "@component/common/Price";
import Discount from "@component/common/Discount";
import useAddToCart from "@hooks/useAddToCart";
import { SidebarContext } from "@context/SidebarContext";
import { useContext, useState, useMemo } from "react";
import { useRouter } from "next/router";
import Link from "next/link";

const ProductCard = ({ product, query }) => {
  const router = useRouter();
  const { handleAddItem, setItem, item } = useAddToCart();
  const { isUpdate, openCartDrawer } = useContext(SidebarContext);
  const [addOn, setAddOn] = useState({
    addOnName: "",
    addOnPrice: 0,
  });

  return (

<div className="pb-4 box-border overflow-hidden flex rounded-md shadow-md flex-col items-center bg-white relative">
<Link className="group pt-2 pb-8 box-border overflow-hidden flex flex-grow  rounded-md flex-col items-center bg-white relative w-full" href={`/product/${product.slug}`} title={product.title}>

    <div className="relative flex justify-center">
      
        <Image
          src={product.image}
          width={160}
          height={160}
          alt={product.title}
          className="object-cover transition duration-300 ease-in-out transform group-hover:scale-105"
          placeholder="blur"
          blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
          style={{
            maxWidth: "100%",
            height: "160px",
          }}
        />
      
    </div>
    <div className="py-2">
      {product.quantity <= 0 && product.ispreOrderAllowed ? (
        <div className="items-center bg-blue-100 text-blue-800 justify-center px-2 py-1 border-0 rounded-full text-xs font-semibold font-serif z-10 left-4 top-4">
          Available in Pre-Order
        </div>
      ) : product.quantity <= 0 ? (
        <div className="items-center bg-red-100 text-red-800 justify-center px-2 py-1 border-0 rounded-full text-xs font-semibold font-serif z-10 left-4 top-4">
          Out of Production
        </div>
      ) : (
        <div className="items-center bg-green-100 text-green-800 justify-center px-2 py-1 border-0 rounded-full text-xs font-semibold font-serif z-10 left-4 top-4">
          In Stock
        </div>
      )}
    </div>
    <div className="w-full px-4 pb-4 overflow-hidden">
      <div className="relative mb-1">
          <h2 className="text-heading text-sm font-medium text-gray-800">
  <span className="line-clamp-2">
    {query && product.highlights && product.highlights.some(h => h.field === "title") ? (
      <div
        dangerouslySetInnerHTML={{
          __html: product.highlights.find(h => h.field === "title").snippet || product.title
        }}
      ></div>
    ) : (
      product.title
    )}
  </span>
</h2>

      </div>

      <Discount product={product} />
    </div>
    <div className=" justify-between w-full px-4 absolute bottom-0">
    <span
        className={
          product.totalSalesCount > 0
            ? "inline-flex items-center justify-center text-xs text-gray-600 font-serif absolutes bottom-10s"
            : "hidden"
        }
      >
        {product.totalSalesCount} sold
        {product.avgRating > 0 && (
          <span className="flex">
            &nbsp;{'·'}&nbsp;
            {Number.isInteger(product.avgRating)
              ? product.avgRating
              : product.avgRating.toFixed(1)}
            <IoStarSharp color="#ffb700" />
          </span>
        )}
      </span>
      <div className="flex justify-between items-center text-heading text-sm sm:text-base space-s-2 md:text-base lg:text-xl">
        <Price product={product} card={true} />
      </div>
    </div>

  </Link>
  <div className="flex justify-center bottom-0 right-0 absolute">
    <button
      onClick={() => {
        handleAddItem(product, addOn);
        openCartDrawer();
      }}
      disabled={product?.quantity < 1 && !product?.ispreOrderAllowed}
      className={`${
        product?.quantity < 1 && !product?.ispreOrderAllowed
          ? "text-sm leading-4 inline-flex items-center font-semibold font-serif text-center justify-center border-0 border-transparent rounded-md focus-visible:outline-none focus:outline-none text-gray-700 px-4 py-2  w-16 h-12 disabled:transform-none disabled:transition-none  disabled:cursor-not-allowed disabled:text-gray-300 transition duration-300 ease-in-out transform hover:scale-105 disabled:shadow-none"
          : "text-sm leading-4 inline-flex items-center cursor-pointer transition ease-in-out duration-300 font-semibold font-serif text-center justify-center  rounded-md focus-visible:outline-none focus:outline-none text-black  bg-gray-9001 hover:bg-red-400 w-16 h-12 hover:text-white"
      }`}
    >
      <span className="text-xl flex items-center">
        <IoBagAddSharp className=" mb-2" />
        
      </span>
    </button>
  </div>
</div>

);
};

export default ProductCard;
